module.exports = __webpack_public_path__ + "static/img/10commitments_4.73b709e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_4.jpg
// module id = /Pkb
// module chunks = 0